<template>
    <el-select 
    size="small" 
    v-model="searcheModel.corp_ids" 
    filterable 
    remote 
    :remote-method="remoteMethod" 
    clearable 
    multiple 
    placeholder="请选择" 
    @change="handleChange"
    @blur="handleBlur"
    @visible-change="getList()" 
    :loading="loading">
        <el-option
            v-for="item in list"
            :key="item.id"
            :label="item.name"
            :value="item.id">
        </el-option>
    </el-select>
</template>


<script>
// import CustomerStdService from "~/services/CustomerStd";
import CommonService from "~/services/common"
export default {
    name: "CorpSelect",
    props: {
        corp_ids: {
            type: Array,
            default: function() {
                // 返回一个新的数组，而不是共享的引用
                return [];
            }
        },
    },
    data() {
        return {
            list: [],
            searcheModel: {},
            loading: false,
        };
    },

    created() {
        this.resetForm();
    },


    methods: {
        // 筛选查询
        submitSearch(params = null) {
            if(params){
                this.searcheModel = params;
            }
            params = _.clone(this.searcheModel);
            _.each(params, (val, key) => {
                // 如果值是假值，除了数字 0 和字符串 '0'，都删除该键
                if (val === undefined || val === null || (typeof val === 'string' && val === '')) {
                    delete params[key];
                }
            })
            //请求侧边栏地区树
            this.getList(params);
        },

        //重置按钮
        resetForm() {
            this.searcheModel = {
                corp_ids: this.corp_ids,
                name: '',
            };
            this.list = []; ``
            this.submitSearch();
        },

        getList(params = {}){
            // loading 动画
            this.loading = true;
            CommonService.getCorpList(params)
            .then((res) => {
                if (res.code == 0) {
                    this.list = res.data;
                }
                this.loading = false;
            })
            .catch((err) => {
                this.loading = false;
                console.error(err);
            });
        },

        remoteMethod(query){
            this.getList({name: query});
        },

        handleChange(val){
            this.$emit("change", val);
        },
        
        handleBlur(event) {
            /**
             * 鼠标移除事件不需要触发。
             * 不然会出现我不选择修改值，会造成当前对象为空的想象。
             */
            console.log('handleBlur:', event);
        },

        //对输入框进行重置     
        reset(){
            this.searcheModel.corp_ids = [];
        }           
    }
}
</script>


// WEBPACK FOOTER //
// src/widgets/CorpSelect.vue